import { SettingScope } from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const patchScopedSettingValuesMutationAtom = createMutationAtomFactory(
  'settings.patchScopedSettingValues',
  (params: {
    scope: SettingScope;
    objectId: string;
    values: Record<string, unknown>;
  }) => ({
    corePatchScopedSettingValues: {
      __args: {
        input: {
          scope: params.scope,
          objectId: params.objectId,
          values: params.values,
        },
      },
    },
  }),
);
